import React from 'react'

import {
  SignatureIcon,
  SignatureOutlinedIcon,
} from 'components/common/custom-icons'
import DefaultButton from './DefaultButton'
import { useTranslation } from 'react-i18next'

const SignatureButton = ({
  selected,
  onPress,
}: {
  selected: boolean
  onPress: { (): void }
}) => {
  const { t } = useTranslation()

  return (
    <DefaultButton
      title={t('eSignature')}
      icon={<SignatureIcon style={{ marginRight: 6 }} height={24} width={24} />}
      hoverIcon={
        <SignatureOutlinedIcon
          style={{ marginRight: 6 }}
          height={24}
          width={24}
        />
      }
      selected={selected}
      onPress={onPress}
    />
  )
}

export default SignatureButton
